module.exports = __webpack_public_path__ + "static/img/celoscope-detail-28.44a80b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-28.jpg
// module id = f6+U
// module chunks = 52